import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/case_studies/baucommunications/01/thumbnail.jpg'

const paperInfo = {
  paperName: 'commmune導入事例_株式会社バウコミュニケーションズ',
  enPaperName: 'caseStudy-BauCommunications',
  thumbnail: thumbnail,
  feature1: 'ユーザー目線のコミュニティプラットフォームの在り方',
  feature2: '精度の高いユーザーインサイト抽出',
  feature3: '効率的な定性データ収集と分析',
  description:
    '幅広いクライアント企業へプロモーション施策の提案を行う株式会社バウコミュニケーションズ様の事例です。BtoB、BtoCにおけるコミュニティ活用方法の理解がより深まる資料です。',
  formSrc: 'https://go.commmune.jp/l/915341/2021-11-30/9yjr6',
  type: 'pardot'
}

const WhitePaperPage = () => {
  return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
